//import React, { ChangeEvent } from 'react';
import styles from './Navigator.module.css';
import {  useCCContext } from '../CC/CCContext';
import CurPage from './curPage';
import Paginator from './Paginator';
import ResultSetSlider from './ResultSetSlider';

function Navigator() {
    const { data } = useCCContext();
    const totalRecords = data.request?.count || 0;

    if(totalRecords===0) {
        return (<div></div>);
    }

    return (
        <div className = {styles.Navigator}>
          <Paginator />
          <CurPage />
         <ResultSetSlider />
        </div>
    )

  }

export default Navigator;